type License = {
    id: string;
    licenseId: string;
};

type OrganizationUserProps = {
    id: string;
    displayName: string;
    mail: string;
    isMonthlyAnalyzedMailLimitReached: boolean;
    license?: License;
};

export default class OrganizationUser {
    id: string;

    displayName: string;

    mail: string;

    isMonthlyAnalyzedMailLimitReached: boolean;

    license?: License;

    constructor({
        id,
        displayName,
        mail,
        isMonthlyAnalyzedMailLimitReached,
        license,
    }: OrganizationUserProps) {
        this.id = id;
        this.displayName = displayName;
        this.mail = mail;
        this.isMonthlyAnalyzedMailLimitReached =
            isMonthlyAnalyzedMailLimitReached;
        this.license = license;
    }
}
